import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';
// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';

//
// components
import { RunwaysForm } from '../components/AerosDetails';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { useTranslation } from '../common/LocalizationProvider';
import { selectAerosArray } from '../createSelectorUtils';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function AddRunways() {
  const t = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const aero =
    useSelector(selectAerosArray).find(
      (item) => item.id === (location.state !== null ? location.state.aeroId : 0)
    ) || {};

  return (
    <Page title={t('ARN_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('add_runway')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <RunwaysForm oaci={aero ? aero.oaci : ''} />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
